module["exports"] = [
  "09## ### ###",
  "0## #### ####",
  "0# #### ####",
  "+421 ### ### ###"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/sk/phone_number/formats.js
 ** module id = 1050
 ** module chunks = 0
 **/